export default __webpack_public_path__ + "static/media/five.f280f1b5.png";